import History from '../../../components/history/history';
import { OuterWrapper } from './history.style';

interface HistoryProps {
  smallTitle?: string;
  title?: string;
  description?: string;
  button?: any;
  image?: any;
  backgroundColor?: string;
  titleColor?: string;
  smallTitleColor?: string;
  descriptionColor?: string;
  cornerImage?: any;
}

const HistorySection: React.FC<any> = ({ data }: { data: HistoryProps }) => {
  return (
    <OuterWrapper backgroundColor={data?.backgroundColor}>
      <History data={data}></History>
    </OuterWrapper>
  );
};

export default HistorySection;
